import styled, { css } from 'styled-components';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';
import Input from '@carvana/showroom-forms/Input';

const ConnectBankCardWrapper = styled.div`
  align-content: center;
  border: 1px solid #d9dde9;
  border-radius: 8px;
  background-color: ${(props) => props.theme.color.neutral.v100};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: 'Brandon Text';
  justify-content: center;
  padding: 24px;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  width: 100%;
  height: 100%;
  margin: 0 auto;
  max-width: 912px;

  @media (min-width: 376px) {
    min-width: 325px;
    justify-content: flex-start;
  }

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-height: 410px;
    padding: 32px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    min-height: auto;
    padding: 40px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xl}px) {
    min-height: 320px;
  }
`;

const ConnectBankTitle = styled.h2`
  color: ${(props) => props.theme.color.primary.v600};
  padding: 0 0 24px 0;
  margin: 0 auto;
  max-width: 912px;
  font-size: 20px;
  line-height: 24px;
`;

const ConnectBankFieldset = styled.fieldset`
  border: none;
  display: flex;
  flex-direction: row;
  margin-top: 30px;
  padding: 0;
  justify-content: space-between;

  & .radio__outline {
    margin-right: 8px;
  }

  // & Input[type='radio']:checked + div.radio__outline {
  //   border-color: #00619e;
  // }

  // & Input[type='radio']:checked + div.radio__outline > div.radio__dot {
  //   background-color: #00619e;
  // }

  & Label {
    color: #6d7184;
  }

  @media (min-width: 376px) {
    max-width: 300px;
  }
`;

const ConnectBankInput = styled(Input)`
  & Input {
    color: #6d7184;
  }

  & Label {
    color: #aab1c7;
    font-weight: 400;
    text-transform: capitalize;
  }

  &:not(:first-child) {
    margin-top: 30px;
  }

  & Input {
    background: white;
    font-weight: normal;
  }

  & input::-webkit-outer-spin-button,
  & input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  & input[type='number'] {
    -moz-appearance: textfield;
  }

  @media (min-width: 376px) {
    max-width: 300px;
  }

  @media screen and (max-width: 767px) {
    & Input:not([disabled]) {
      font-size: 16px;
    }
  }
`;

const ConnectButton = css`
  padding: 0;
  width: 100%;
  min-width: 200px;
  min-height: 56px;
  font-size: 14px;
  margin-top: 30px;
`;

const ConnectBankButton = styled(PrimaryButton)`
  ${ConnectButton}

  @media (min-width: 376px) {
    margin-right: 14px;
    max-width: 300px;
    text-align: center;
  }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  min-height: 200px;
`;

const HR = styled.hr`
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  width: 100%;
  border-bottom-color: transparent;
`;

export {
  ConnectBankCardWrapper,
  ConnectBankTitle,
  ConnectBankFieldset,
  ConnectBankButton,
  ConnectBankInput,
  SpinnerWrapper,
  HR,
};
